export default {
    title: 'E-Mails',

    id: 'ID',
    recipient: 'Empfänger',
    mailTemplate: 'E-Mailvorlage',
    process: 'Vorgang',
    statisticProcess: 'Statistikvorgang',
    status: 'Status',
    updated_at: 'Zuletzt aktualisiert',
}